import { render, staticRenderFns } from "./employment-income.vue?vue&type=template&id=47a4acb6&scoped=true"
import script from "./employment-income.vue?vue&type=script&lang=js"
export * from "./employment-income.vue?vue&type=script&lang=js"
import style0 from "./employment-income.vue?vue&type=style&index=0&id=47a4acb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4acb6",
  null
  
)

export default component.exports